import en from './en'
import cn from './cn'
import jp from './jp'
import de from './de'
import fr from './fr'
import es from './es'
import it from './it'
import nl from './nl'
import pt from './pt'

export default {
  en,
  cn,
  jp,
  de,
  fr,
  es,
  it,
  nl,
  pt,
}
